import MypageEventContainer from './MypageEventContainer';
export default MypageEventContainer;
